import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { AppConfigService } from './app-config.service';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { SiteSettingsService } from './site-settings.service';
import { get } from 'lodash';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./app-config.service";
import * as i3 from "@angular/router";
import * as i4 from "./site-settings.service";
var PageResolverService = /** @class */ (function () {
    function PageResolverService(http, appConfigService, router, siteSettingsService) {
        this.http = http;
        this.appConfigService = appConfigService;
        this.router = router;
        this.siteSettingsService = siteSettingsService;
        this.cache = new Map();
        this.pageDataChanged$ = new Subject();
        var initialPageData = get(document.getElementById('initialPageData'), 'innerHTML');
        this.initialPageData = initialPageData ? JSON.parse(initialPageData) : null;
    }
    PageResolverService.prototype.resolve = function (route) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var path, queryParams, key, cached, utmParams, siteSettings;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = "/" + route.url.join('/');
                        queryParams = this.getQueryAsString(route.queryParams);
                        key = queryParams.length === 0 ? path : path + queryParams;
                        cached = this.cache.get(key);
                        if (!!cached) return [3 /*break*/, 4];
                        if (!(this.initialPageData && this.initialPageData.getByUrl)) return [3 /*break*/, 1];
                        cached = this.parseResponse(this.initialPageData.getByUrl);
                        this.initialPageData.getByUrl = undefined;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.byPath(path, queryParams)];
                    case 2:
                        cached = _a.sent();
                        _a.label = 3;
                    case 3:
                        utmParams = this.getUtmParams(cached);
                        if (Object.keys(utmParams).length === 0) {
                            this.cache.set(key, cached);
                        }
                        _a.label = 4;
                    case 4:
                        if (!!cached) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.siteSettingsService.getSiteSettings()];
                    case 5:
                        siteSettings = _a.sent();
                        this.router.navigate([siteSettings.pageNotFoundPageUrl]);
                        _a.label = 6;
                    case 6:
                        this.pageDataChanged$.next(cached);
                        return [2 /*return*/, cached];
                }
            });
        });
    };
    PageResolverService.prototype.byPath = function (path, query) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var currentHost, host;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        currentHost = this.appConfigService.getHostName().replace(/\/$/, "");
                        return [4 /*yield*/, this.getHost(currentHost)];
                    case 1:
                        host = _a.sent();
                        if (currentHost === host) {
                            return [2 /*return*/, this.http.get("ubaseline/api/node/getByurl?url=" + host + path + query).pipe(map(function (res) { return _this.parseResponse(res); })).toPromise()];
                        }
                        else {
                            window.location.href = host + path + query;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    PageResolverService.prototype.getHost = function (currentHost) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var culture;
            return tslib_1.__generator(this, function (_a) {
                culture = this.tryGetCulture();
                if (culture) {
                    return [2 /*return*/, this.http.get("ubaseline/api/domain/getDomainByCulture?culture=" + culture).pipe(map(function (res) { return res.replace(/\/$/, ""); })).toPromise()];
                }
                else {
                    return [2 /*return*/, currentHost.replace(/\/$/, "")];
                }
                return [2 /*return*/];
            });
        });
    };
    PageResolverService.prototype.tryGetCulture = function () {
        var cultureHash = "#?culture=";
        return window.location.search.indexOf("preview") > -1 && window.location.hash.startsWith(cultureHash) ?
            window.location.hash.split(cultureHash)[1] :
            "";
    };
    PageResolverService.prototype.parseResponse = function (res) {
        if (res === null)
            return res;
        if (!res.isDefaultModel)
            return res;
        var data = {};
        res['properties'].forEach(function (prop) {
            data[prop['alias']] = {
                value: prop['value'],
                editorAlias: prop['editorAlias']
            };
        });
        return data;
    };
    PageResolverService.prototype.getUtmParams = function (data) {
        return data && data.utmConfiguration ? data.utmConfiguration.value.params : {};
    };
    PageResolverService.prototype.getQueryAsString = function (queryParams) {
        if (!queryParams || Object.keys(queryParams).length === 0) {
            return "";
        }
        var query = [];
        Object.keys(queryParams).forEach(function (key) {
            query.push(key + '=' + queryParams[key]);
        });
        return "?" + query.join('%26');
    };
    PageResolverService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PageResolverService_Factory() { return new PageResolverService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.AppConfigService), i0.ɵɵinject(i3.Router), i0.ɵɵinject(i4.SiteSettingsService)); }, token: PageResolverService, providedIn: "root" });
    return PageResolverService;
}());
export { PageResolverService };
